
import { HttpResponse, defaultHttpResponse } from "../auth/AuthInterface";

import { ParteProps } from "./ParteInterface";
import { TipoPrestacionProps } from "../catalogos/TipoPrestacionInterface";
import { PaginacionProps } from "../global/PaginacionInterface";

// Definición de defaults

export const defaultExpediente: ExpedienteProps = { 
    idExpediente: 0,
    cuantia: '',
    numeroFolio: '',
    numeroExpediente: '',
    idTipoJuicio: 0,
    tipoJuicio: '',
    idJuez: 0,
    juez: '',
    idSecretario:0,
    secretario:  '',
    idSecretarioTramite: 0,
    secretarioTramite: '',
    idSecretarioEjecucion: 0,
    secretarioEjecucion: '',
    idSecretarioTramiteMenor: 0,
    secretarioTramiteMenor: '',
    idEtapa: 0,
    etapa: '',
    idSubEtapa: 0,
    subEtapa: '',
    idJuzgadoOrigen: 0,
    juzgadoOrigen: '',
    idTipoCalificacion: 0,
    tipoCalificacion: '',
    idEstatus: 0,
    estatus: '',
    medioImpugnacion: false,
    medioPreparatorio: false,
    incidente: false,
    partes: [],
    actores: [],
    demandados: [],
    prestaciones:[],
    caratula: '',
    digitalizacion: '',
}

export const defaultExpedienteResponse: BuscarExpedienteResponse = {
    ...defaultHttpResponse,
    ...defaultExpediente,
};

export const defaultExpedienteAnterior: ExpedienteAnteriorProps = { 
    idExpediente: 0, 
    numeroExpediente: '', 
    numeroFolio: '', 
    idAutoridad: 0,     
    idTipoJuicio: 0, 
    tipoJuicio: '', 
    juez: '', 
    juzgado: '', 
    presentante: '', 
    sintesis: '', 
    referencia: 0, 
    idTipoSentencia: 0, 
    partes: [], 
    idEtapa: 0, 
    etapa: '', 
    idSubEtapa: 0, 
    subEtapa: '', 
    encontrado: false, 
    digitalizacion: '',
}

export const defaultExpedienteAnteriorResponse: ExpedienteAnteriorResponse = {
    ...defaultHttpResponse,
    ...defaultExpedienteAnterior,
};

export const defaultGenerarCaratula: GenerarCaratulaResponse = {
    ...defaultHttpResponse,
    caratula: '',
};

export const defaultConsultaExpedienteEtapa: ConsultaExpedienteEtapaResponse = {
    currentPageIndex: 0,
    pageCount: 0,
    recordsCount: 0,
    records: [],
};

// Creación de interfaces

export interface ExpedienteProps {
    idExpediente:             number;
    cuantia:                  string;
    numeroFolio:              string;
    numeroExpediente:         string;
    idTipoJuicio:             number;
    tipoJuicio:               string;
    idJuez:                   number;
    juez:                     string;
    idSecretario:             number;
    secretario:               string;
    idSecretarioTramite:      number;
    secretarioTramite:        string;
    idSecretarioEjecucion:    number;
    secretarioEjecucion:      string;
    idSecretarioTramiteMenor: number;
    secretarioTramiteMenor:   string;
    idEtapa:                  number;
    etapa:                    string;
    idSubEtapa:               number;
    subEtapa:                 string;
    idJuzgadoOrigen:          number;
    juzgadoOrigen:            string;
    idTipoCalificacion:       number;
    tipoCalificacion:         string;
    idEstatus:                number;
    estatus:                  string;
    fecha?:                   Date;
    medioImpugnacion:         boolean;
    medioPreparatorio:        boolean;
    incidente:                boolean;
    partes:                   ParteProps[];
    actores:                  string[];
    demandados:               string[];
    prestaciones:             string[];
    caratula:                 string;
    digitalizacion:           string;
}

export interface ExpedienteAnteriorProps {
    idExpediente:       number;
    idTipoJuicio:       number;
    tipoJuicio:         string;
    idEtapa:            number;
    etapa:              string;
    idSubEtapa:         number;
    subEtapa:           string;
    idAutoridad:        number;
    numeroExpediente:   string;
    numeroFolio:        string;
    juez:               string;
    juzgado:            string;
    presentante:        string;
    sintesis:           string;
    digitalizacion:     string;
    referencia:         number;
    encontrado:         boolean;
    partes:             ExpedienteAnteriorParteProps[];
    idTipoSentencia:    number;
    fechaCitacion?:     Date;
    fechaRadicacion?:   Date;
    fechaPresentacion?: Date;
}

export interface ExpedienteAnteriorParteProps {
    nombre:             string;
    apellidoPaterno:    string;
    apellidoMaterno:    string;
    sexo:               number;
    personaMoral:       number;
    tipo:               string;
}

export interface BuscarExpedienteParams {
    numeroExpediente:   string;
    idAutoridad:        number;
}

export interface BuscarExpedienteResponse extends HttpResponse, ExpedienteProps { }

export interface BuscarExpedienteAnteriorParams {
    numeroExpediente:      string;
    idAutoridad:           number;
}

export interface ExpedienteAnteriorResponse extends HttpResponse, ExpedienteAnteriorProps { }

export interface GuardarExpedienteAnteriorParams {
    idTipoJuicio:           number;
    idEtapa:                number;
    idSubEtapa:             number;
    referencia:             number;
    idTipoSentencia:        number;
    idAutoridad:            number;
    numeroExpediente:       string;
    numeroFolio:            string;      
    fechaCitacion:          string;    
    fechaConclusion:        string;    
    fechaRadicacion?:       Date;
    fechaPresentacion?:     Date;
    partes:                 ExpedienteAnteriorParteProps[];
}

export interface GenerarCaratulaExpedienteProps {
    idExpediente:             number;
}

export interface GenerarCaratulaResponse {
    success:                  boolean;
    message:                  string;
    caratula:                 string;
}

export interface DigitalizacionProps {
    idDigitalizacion:   number;
    url:                string;
    fecha?:             Date;
}

export interface AgregarPartesExpedienteParams {
    idExpediente:   number;
    partes:         ParteProps[];
}

export interface EditarExpedienteParams {
    idExpediente:   number;
    idTipoJuicio:   number;
    cuantia:        string;
}

export interface AgregarPrestacionesExpedienteParams {
    idExpediente:   number;
    prestaciones:   TipoPrestacionProps[];
}

export interface ConsultaExpedienteEtapaParams extends PaginacionProps {
    idAutoridad:            number;
    idMateria:              number;
    idEtapa:                number;
    idSubEtapa:             number;
    idEstatus:              number;
    numeroExpediente:       string;
}

export interface DescargarExpedientesEtapaProcesalParams {
    idAutoridad:            number;
    idMateria:              number;
    idEtapa:                number;
    idSubEtapa:             number;
    idEstatus:              number;
    numeroExpediente:       string;
}

export interface ConsultaExpedienteEtapaDetalleProps {
    idExpediente:           number;
    numeroExpediente:       string;
    idEtapa:                number;
    etapa:                  string;
    idSubEtapa:             number;
    subEtapa:               string;
    idEstatus:              number;
    estatus:                string;
    dias:                   number;
    actores:                string;
    demandados:             string;
    expediente:             ExpedienteProps;
    fechaInicio?:           Date;
    fechaUltimoMovimiento?: Date;
}

export interface ConsultaExpedienteEtapaResponse {
    currentPageIndex:       number;
    pageCount:              number;
    recordsCount:           number;
    records:                ConsultaExpedienteEtapaDetalleProps[];
}